import * as Yup from 'yup'

import { SchedulePreference } from '@b-stock/location-api-client'

import type { CheckedType } from '@pages/businessProfile/addressBook/addAddressForm/shared.d'

Yup.addMethod(Yup.string, 'schedulingPolicy', function (errorMesage: string) {
  const valueTest = (
    value: string | undefined,
    ctx: Yup.TestContext<Yup.Maybe<Yup.AnyObject>>
  ): boolean | Yup.ValidationError => {
    const valid = value === SchedulePreference.ContactFirst
    if (!valid) {
      return ctx.createError({ message: errorMesage })
    }
    return true
  }

  return this.when(['checked'], {
    // `when` hands over the value of the `checked` field itself, i.e. the
    // day -> boolean map, not the object that wraps it.
    is: (checked: CheckedType) => !Object.values(checked).find((el) => el),
    then: () => this.test(valueTest),
    otherwise: () => Yup.string().required(),
  })
})

declare module 'yup' {
  interface StringSchema {
    schedulingPolicy(errorMesage: string): Yup.StringSchema
  }
}
